import {
  DefaultCustomLayoutDrawerProps,
  Drawer,
} from 'module/ui/components/atoms/drawer';
import { FC, useMemo } from 'react';
import { AddFiles, AddFilesPayload } from './add-files';

interface Props {
  open: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AddFilesPayload) => Promise<void>;
}
export const AddFilesDrawer: FC<Props> = ({
  open,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer
      width="672px"
      open={open}
      onClose={onClose}
      {...DefaultCustomLayoutDrawerProps}
    >
      <AddFiles onClose={onClose} onDone={onDone} breadcrumbs={breadcrumbs} />
    </Drawer>
  );
};
